import { COMPOSITION_TEMPLATES, type CompositionTemplateId } from '../../../composition/templates';

export function TemplatePicker({
  onApply,
}: {
  readonly onApply: (id: CompositionTemplateId) => void;
}) {
  return (
    <fieldset className="composition-template-picker">
      <legend>Apply template</legend>
      <div className="composition-template-choices">
        {COMPOSITION_TEMPLATES.map(({ id, name, description }) => (
          <button
            type="button"
            key={id}
            aria-label={`Apply ${name} template`}
            title={description}
            className="composition-template-choice"
            onClick={() => onApply(id)}
          >
            <span
              className={`composition-template-schematic composition-template-${id}`}
              aria-hidden="true"
            >
              <span className="template-title" />
              <span className="template-subtitle" />
              <span className="template-map" />
              <span className="template-legend" />
              <span className="template-inset" />
              <span className="template-scale" />
              <span className="template-north" />
            </span>
            <span>{name}</span>
          </button>
        ))}
      </div>
      <small className="composition-clipping-note">
        Apply a starting layout, then edit any object.
      </small>
    </fieldset>
  );
}
